import { render, staticRenderFns } from "./BaseAvatar.vue?vue&type=template&id=1eca6e04"
import script from "./BaseAvatar.vue?vue&type=script&lang=js"
export * from "./BaseAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports